// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"slim-hero-banner_wrapper__MIddz","slide-indicator":"slim-hero-banner_slide-indicator__lbM2b"};